import React, { useEffect } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Input from "../Input"; // Assuming Input component is reused
import {
  createCompany,
  getCompanyById,
  resetResponseState,
  selectCompany,
  selectCreateError,
  selectStatus,
  selectLoading,
  selectCreationStatus,
  resetCreationStatus,
} from "../../redux/company/companySlice";
import { CompanySchema } from "../../utils/formik-schema/companySchema";
import Loader from "../custom-components/Loader/Loader";

const initialValues = {
  email: "",
  name: "",
  apiPassword: "",
  apiUsername: "",
  formLink: "",
  clientId: "",
};

function CompanyForm({ setShow, setRefresh }) {
  const loading = useSelector(selectLoading);
  const error = useSelector(selectCreateError);
  const company = useSelector(selectCompany);
  const status = useSelector(selectCreationStatus);
  const dispatch = useDispatch();

  const handleCreateCompany = async (values) => {
    try {
      dispatch(createCompany(values));
      // Reset values after submission
      values.email = "";
      values.name = "";
      values.apiPassword = "";
      values.apiUserName = "";
      values.formLink = "";
      values.clientId = "";
      values.isBypass = false;

      return;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }

    dispatch(getCompanyById()); // Fetch company data after creation
    dispatch(resetResponseState()); // Reset response state after handling
  }, [status, error]);

  useEffect(() => {
    if (status === "success") {
      setShow(false);
      setRefresh(true);
      dispatch(resetCreationStatus());
      // dispatch(getAllCompanies());

      toast.success("Company Created");
    }
  }, [status]);

  return (
    <div className="w-96">
      <h2 className="text-2xl font-semibold text-gray-900 my-4">
        Create Company
      </h2>
      <Formik
        initialValues={initialValues}
        validationSchema={CompanySchema}
        onSubmit={handleCreateCompany}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <Input
              name="name"
              type="text"
              placeholder="Client Name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
            />
            <Input
              name="email"
              type="email"
              placeholder="Client Email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.email}
              touched={touched.email}
            />
            <Input
              name="apiUsername"
              type="text"
              placeholder="API Username"
              value={values.apiUsername}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.apiUsername}
              touched={touched.apiUsername}
            />
            <Input
              name="apiPassword"
              type="password"
              placeholder="API Password"
              value={values.apiPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.apiPassword}
              touched={touched.apiPassword}
            />
            <Input
              name="clientId"
              type="text"
              placeholder="Client ID"
              value={values.clientId}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.clientId}
              touched={touched.clientId}
            />
            <Input
              name="formLink"
              type="text"
              placeholder="Form Link"
              value={values.formLink}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.formLink}
              touched={touched.formLink}
            />

            {loading ? (
              <Loader size="w-8 h-8" />
            ) : (
              <div className="flex gap-2 justify-center mt-2">
                <button
                  className="px-4 py-2 rounded-lg w-full shadow-md hover:-translate-y-1 transition-all hover:shadow-lg active:translate-y-0 active:shadow bg-white text-gray-500 border border-slate-300"
                  onClick={() => setShow(false)} // Close modal on cancel
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg w-full shadow-md hover:-translate-y-1 transition-all hover:shadow-lg active:translate-y-0 active:shadow bg-blue-700 hover:bg-blue-950 text-white"
                >
                  Create Company
                </button>
              </div>
            )}
          </form>
        )}
      </Formik>
    </div>
  );
}

export default CompanyForm;
